import { useSelector } from 'react-redux';
import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';

const FrequencyPicker = () => {
  const clubSignup = useSelector((state) => state.clubSignup.data);
  const { frequenciesOffered } = clubSignup.club.subscription;

  return (
    <Field
      name="frequency"
      component={SelectField}
      optionArray={frequencyOptionArray(frequenciesOffered)}
      label="Shipment Frequency"
      required
    />
  );
};

export default FrequencyPicker;

const frequencyOptionArray = (frequencies) => {
  const array = [];
  frequencies.forEach((frequency) => {
    const option =
      frequency === 1 ? 'Every Month' : `Every ${frequency} Months`;
    array.push({ option, value: frequency });
  });
  return array;
};
